import React from 'react';
import { FlightWorkerProvider } from '../hooks/use-flight-worker';
import ApplicationBootstrap from './ApplicationBootstrap';
import { ApplicationFrame } from './ApplicationFrame';

export default function ApplicationRoute(props: { children?: React.ReactNode }) {
    return (
        <ApplicationBootstrap>
            <FlightWorkerProvider>
                <ApplicationFrame>{props.children}</ApplicationFrame>
            </FlightWorkerProvider>
        </ApplicationBootstrap>
    );
}
